import React, { useState } from "react";
import axios from "axios";
import '../assets/GurukulSamriddhi.css';
import gurukulvideo from '../assets/videos/Gurukul-site-video.mp4';
import brochure from '../assets/pdf/Gurukulbrochure.pdf';
import gurukulLogo from '../assets/pdf/gurukul-logo.webp';


const GurukulSamriddhi = () => {
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        location: '',
        experience: '',
        businessType: ''
    });
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);

    const toggleModal = () => {
        setShowModal(!showModal);
        setSubmitted(false);
        setErrors({});
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.phone || !/^[0-9]{10}$/.test(formData.phone)) newErrors.phone = "Valid 10-digit phone number required";
        if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Valid email required";
        if (!formData.location) newErrors.location = "Location is required";
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        axios.post("https://www.samriddhidevelopers.in/backend/franchise-enquiry.php", formData)
            .then(res => {
                setSubmitted(true);
                setFormData({
                    name: '',
                    phone: '',
                    email: '',
                    location: '',
                    experience: '',
                    businessType: ''
                });
                setErrors({});
                setTimeout(() => {
                    setSubmitted(false);
                    setShowModal(false);
                }, 3000);
            })
            .catch(err => {
                console.error("Submission error:", err);
                alert("Something went wrong. Please try again later.");
            });
    };

    return (
        <section className="gurukul-section">
            <div className="gurukul-container">
                <div className="gurukul-left">
                    {/* <video className="gurukul-video" controls>
                        <source src={gurukulvideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video> */}

                    <img src={gurukulLogo} loading="lazy" className="gurukul-logo" alt="Gurukul-logo"></img>

                    <button className="gurukul-button" onClick={toggleModal}>Become a Franchise Partner</button>
                </div>

                <div className="gurukul-right">
                    <h2 className="gurukul-title">
                        Introducing Gurukul Samriddhi – A Revolution in Real Estate Learning
                    </h2>
                    <p className="gurukul-description">
                        Samriddhi Group proudly launches Gurukul Samriddhi – an initiative
                        dedicated to empowering real estate professionals across India. With
                        a focus on training, franchise development, and business networking,
                        Gurukul Samriddhi aims to build India’s largest network of skilled
                        channel partners (CPs), brokers, and agents.
                    </p>

                    <div className="gurukul-cards">
                        <div className="gurukul-card">
                            <h4>What is Gurukul Samriddhi?</h4>
                            <p>A structured training ecosystem for CPs, Brokers & Agents to thrive.</p>
                        </div>
                        <div className="gurukul-card">
                            <h4>Our Services</h4>
                            <ul>
                                <li>Franchise Training Programs</li>
                                <li>Builder Networking Events</li>
                                <li>Real Estate Certification Courses</li>
                                <li>Weekly Webinars & Seminars</li>
                            </ul>
                        </div>
                        <div className="gurukul-card">
                            <h4>Our Presence</h4>
                            <p>20+ Districts | 200 Talukas | Pan-India Expansion</p>
                        </div>
                        <div className="gurukul-card">
                            <h4>Our Mission</h4>
                            <p>“To build India’s largest, skilled real estate community.”</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="gurukul-footer">
                <h3>Let’s Build the Future Together!</h3>
                <div className="gurukul-footer-buttons">
                    <button>Contact Us</button>

                    <a href={brochure} download>
                        <button>Download Brochure</button>
                    </a>
                    <button onClick={toggleModal}>Franchise Enquiry</button>
                </div>
            </div>

            {showModal && (
                <div className="fr-modal-overlay" onClick={toggleModal}>
                    <div className="fr-modal-content" onClick={(e) => e.stopPropagation()}>
                        <h3>Franchise Enquiry Form</h3>
                        <form className="franchise-form" onSubmit={handleSubmit}>
                            <label>Full Name</label>
                            <input name="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" required />
                            {errors.name && <span className="error">{errors.name}</span>}

                            <label>Mobile Number</label>
                            <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter mobile number" required />
                            {errors.phone && <span className="error">{errors.phone}</span>}

                            <label>Email Address</label>
                            <input name="email" value={formData.email} onChange={handleChange} placeholder="Enter email" required />
                            {errors.email && <span className="error">{errors.email}</span>}

                            <label>City / Taluka / District</label>
                            <input name="location" value={formData.location} onChange={handleChange} placeholder="Enter location" required />
                            {errors.location && <span className="error">{errors.location}</span>}

                            <label>Real Estate Experience (in years)</label>
                            <input name="experience" value={formData.experience} onChange={handleChange} placeholder="Years of experience" />

                            <label>Current Business Type</label>
                            <input name="businessType" value={formData.businessType} onChange={handleChange} placeholder="Broker / CP / Agent / Other" />

                            <button type="submit" className="fr-submit-button">Submit</button>
                            <button type="button" className="fr-close-button" onClick={toggleModal}>Close</button>

                            {submitted && <p className="fr-success-message">Form submitted successfully!</p>}
                        </form>
                    </div>
                </div>
            )}
        </section>
    );
};

export default GurukulSamriddhi;
